import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { ErrorState, LoadingState } from "@/components/app/AppUI";
import { eventRepository } from "@/data/repositories";
import { EventWorkspace } from "@/features/events/EventWorkspace";

export const Route = createFileRoute("/_authenticated/app/eventos/$id")({ component: EventDetail });

/**
 * Una boda con cliente se gestiona en la ficha del cliente. Sólo un evento
 * sin cliente se abre aquí, en el espacio antiguo.
 */
function EventDetail() {
  const { id } = Route.useParams();
  const event = useQuery({ queryKey: ["event", id], queryFn: () => eventRepository.get(id) });

  if (event.isLoading) return <LoadingState />;
  if (event.error || !event.data)
    return <ErrorState message={event.error?.message ?? "Evento no encontrado"} />;
  if (event.data.client_id)
    return <Navigate to="/app/clientes/$id" params={{ id: event.data.client_id }} replace />;

  return (
    <div className="space-y-6">
      <Link
        to="/app/clientes"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" /> Volver a clientes
      </Link>
      <EventWorkspace eventId={id} admin />
    </div>
  );
}
